export default function getDropdownOptions(array, labelKey, valueKey = 'id') {
    return array.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }))
  }
  